import React from 'react';

import { Logout } from '@app/dev/actions/login';
import { useTranslation } from '@common/hooks/translation';
import { useDispatch } from 'react-redux';

import './style.scss';

export const LogoutConfirmation = ({ closePopup }) => {
  const t = useTranslation();
  const dispatch = useDispatch();

  const onConfirm = () => {
    dispatch(Logout());
    closePopup();
  };

  return (
    <div className="popup-content popup-small">
      <div className="title-row">
        <p className="title-row-text">{t('sign out')}</p>
      </div>
      <div className="central-text-row">
        <p className="central-text">{t('Are you sure you want to sign out ?')}</p>
      </div>
      <div className="main-middle-row">
        <div className="container-for-icon">
          <i className="global-icon icon-logout main-middle-icon" />
        </div>
      </div>
      <div className="popup-actions">
        <button
          type="button"
          onClick={closePopup}
          className="popup-cancel-button"
        >
          {t('No')}
        </button>
        <button
          type="button"
          onClick={onConfirm}
          className="popup-confirm-button"
        >
          {t('Yes')}
        </button>
      </div>
    </div>
  );
};
